import { toJS, autorun, observable, action, computed } from 'mobx'
import client from '../../../helpers/client'
import { asNormalizedMaps, asNormalizedArrays } from '../../../helpers/json-normalizer'

class Store {
  @observable ready = false
  @observable loading = true
  @observable franchise
  @observable designTemplates = []
  @observable categories = []
  @observable designCategoryTags = []
  @observable designCategoryLayouts = []
  @observable activeCategory
  @observable activeTag
  @observable activeLayout

  constructor({ widgetStore }) {
    this.widgetStore = widgetStore
    this.host = widgetStore.host
  }

  async setup(categoryId) {
    this.loading = true
    await this.loadFranchise()

    if(categoryId) {
      this.categoryId = categoryId
    }

    await this.loadDesignTemplates()
    this.ready = true
    this.loading = false

  }

  loadDesignTemplates() {
    let url = `${this.host}/api/v1/design_templates?include=design_template_category,design_category_tags,design_category_layouts`
    if(this.categoryId) {
      url = `${url}&design_template_category_id=${this.categoryId}`
    }

    return client.get(url)
      .then(response => {
        const data = asNormalizedMaps(response.data)

        this.designTemplates = Array.from(data.designTemplate ? data.designTemplate.values() : [])
          .sort((a, b) => a.attributes.name.localeCompare(b.attributes.name))
        this.categories = Array.from(data.designTemplateCategory ? data.designTemplateCategory.values() : [])
          .sort((a, b) => a.attributes.name.localeCompare(b.attributes.name))
        this.designCategoryTags = Array.from(data.designCategoryTag ? data.designCategoryTag.values() : [])
          .sort((a, b) => a.attributes.name.localeCompare(b.attributes.name))
        this.designCategoryLayouts = Array.from(data.designCategoryLayout ? data.designCategoryLayout.values() : [])
          .sort((a, b) => a.attributes.name.localeCompare(b.attributes.name))
      })
      .catch(error => (this.widgetStore.unrecoverableError = error))
  }

  loadFranchise() {
    return client.get(`${this.host}/api/v1/franchise`)
      .then(response => {
        const data = asNormalizedArrays(response.data)
        this.franchise = Object.values(data.franchise)[0]
      })
      .catch(error => (this.widgetStore.unrecoverableError = error))
  }

  @computed get activeDesignTemplates() {
    let designTemplates = this.designTemplates

    if(this.activeCategory) {
      designTemplates = designTemplates
        .filter(designTemplate => designTemplate.relationships.category.data.id === this.activeCategory.id)
    }

    if(this.activeTag) {
      designTemplates = designTemplates
        .filter(designTemplate => {
          const tagIds = designTemplate.relationships.designCategoryTags.data.map(tag => tag.id)
          return tagIds.includes(this.activeTag.id)
        })
    }

    if(this.activeLayout) {
      designTemplates = designTemplates
        .filter(designTemplate => {
          const layoutIds = designTemplate.relationships.designCategoryLayouts.data.map(layout => layout.id)
          return layoutIds.includes(this.activeLayout.id)
        })
    }

    return designTemplates
  }
}

export default Store
